import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Select from "react-select";

import { create } from '@api/v4/resources/metadata_conversions';
import { update } from '@api/v4/metadata_conversions';

import './styles/metadata_conversions_form.scss';

const Form = ({
  resourceType,
  resourceKey,
  refreshData,
  editableKey,
  setEditableKey,
  setShowForm,
  selectedItem,
}) => {
  const [convert_to_tags, setConvertToTags] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [metadata_term, setMetaTerm] = useState('');
  const [key_term, setKeyTerm] = useState('');
  const [error, setError] = useState(null);

  const submit = (event) => {
    event.preventDefault();
    setSubmitting(true);
    setError(null);
    if (editableKey) {
      update({
        id: editableKey,
        metadata_term,
        key_term,
        convert_to_tags: !!convert_to_tags,
      }).then(() => {
        refreshData();
        setEditableKey(null);
        setShowForm(false);
        Notify.create({ type: "success", key_term: "Mapping Updated!" });
      }).catch(({ errors }) => {
        setError(errors);
      }).finally(() => {
        setSubmitting(false);
      });
    } else {
      create({
        resourceType,
        resourceKey,
        metadata_term,
        key_term,
        convert_to_tags: !!convert_to_tags,
      }).then(() => {
        refreshData();
        setEditableKey(null);
        setShowForm(false);
        Notify.create({ type: "success", key_term: "Mapping Created!" });
      }).catch(({ errors }) => {
        setError(errors);
      }).finally(() => {
        setSubmitting(false);
      });
    }
  };

  const closeForm = () => {
    setEditableKey(null);
    setShowForm(false);
  };

  useEffect(() => {
    if (selectedItem) {
      setMetaTerm(selectedItem.metadata_term);
      setKeyTerm(selectedItem.key_term);
    }
  }, [selectedItem]);

  const metaFieldSuggestions = ["width", "filter", "height", "bit_depth", "file_size", "file_type", "mime_type", "color_type", "image_size", "interlace", "image_width", "megapixels", "colorspace", "compression", "image_height", "frame_count", "aspect_ratio", "average_color", "file_access_date", "file_modify_date", "file_type_extension", "has_clipping_path", "date_file_modified", "file_inode_change_date", "keywords"];

  return (
    <>
      <div className="metadata_conversions--cancel-edit" onClick={closeForm} onKeyPress={closeForm} role="button" tabIndex={0}>
        <span className="bff-arrow-left" />
        <span>{bfTranslate('Back')}</span>
      </div>
      <form
        className="metadata_conversions--form"
        onSubmit={submit}
      >
        <label
          className="brandfolder-label"
          htmlFor="select-metadata-conversion-target"
        >
          {bfTranslate('Convert metadata into')}
        </label>
        <Select
          clearable={false}
          name="select-metadata-conversion-target"
          onChange={(option) => setConvertToTags(option.value)}
          options={[
            { value: false,
              label: bfTranslate("Custom Fields") },
            { value: true,
              label: bfTranslate("Tags") }
          ]}
          searchable={false}
          value={convert_to_tags}
        />

        <div>
          <label
            className="brandfolder-label"
            htmlFor="mapping-metadata_term"
          >
            {bfTranslate('Select embedded metadata field')}
            <input
              className="brandfolder-input"
              disabled={submitting}
              id="mapping-metadata_term"
              list="suggestions"
              name="mapping-metadata_term"
              onChange={({ target }) => setMetaTerm(target.value)}
              required
              type="text"
              value={metadata_term}
            />
            <datalist id="suggestions">
              { metaFieldSuggestions.map((field) => <option key={field} value={field} />)}
            </datalist>
          </label>
        </div>

        { !convert_to_tags
          && (
            <div>
              <label
                className="brandfolder-label"
                htmlFor="mapping-key_term"
              >
                {bfTranslate('Name your new custom field key')}
                <input
                  className="brandfolder-input"
                  disabled={submitting}
                  id="mapping-key_term"
                  name="mapping-key_term"
                  onChange={({ target }) => setKeyTerm(target.value)}
                  required
                  type="text"
                  value={key_term}
                />
              </label>
            </div>
          )
        }

        <div className={`metadata_conversions--button-container ${error && 'has-error'}`}>
          {!!error && (
            <p className="error-message">{error}</p>
          )}
          <button
            className="button primary md"
            disabled={submitting}
            type="submit"
          >
            {editableKey ? bfTranslate("Update Conversion") : bfTranslate("Create Conversion")}
          </button>
        </div>
      </form>
    </>
  );
};

Form.propTypes = {
  resourceKey: PropTypes.string.isRequired,
  refreshData: PropTypes.func,
  resourceType: PropTypes.string,
  editableKey: PropTypes.string,
  setEditableKey: PropTypes.func.isRequired,
  setShowForm: PropTypes.func.isRequired,
  selectedItem: PropTypes.shape({
    id: PropTypes.string,
    metadata_term: PropTypes.string,
    key_term: PropTypes.string,
  })
};

Form.defaultProps = {
  editableKey: null,
  refreshData: () => {},
  resourceType: 'brandfolder',
  selectedItem: null,
};

export default Form;
